// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__yP8pi","login":"Login_login__dcF7k","googleButton":"Login_googleButton__eWVHm"};